import React from 'react'
import styled from 'styled-components'

const StyledWrapper = styled.li`
  color: #4e5d78;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.71;
  padding: 15px 18px;
  position: relative;
  white-space: nowrap;

  ${({ theme }) => theme.media.desktop} {
    padding: 20px 24px;
  }
`

const Tab = ({ children, onClick }) => {
  const handleClick = e => {
    onClick(e)
  }

  return <StyledWrapper onClick={e => handleClick(e)}>{children}</StyledWrapper>
}

export default Tab
